import { EDA } from "motw_core/Dreams/EDreamAttribute";
import { dreamService } from "motw_core/Services/DreamService";
import { hashTagsService } from "motw_core/Services/HashTagsService";
import * as React from "react";
import ChevronPanel from "source/app/presentation/Shared/ChevronPanel/ChevronPanel";
import { GetDreamRows } from "../../HashTags/GetDreamRows";
import { DreamEditor } from "../DreamEditor";
import { DreamEditorHashTagLink } from "./DreamEditorHashTagLink";

export function DreamEditorHashTags({
    DreamEditor,
}: {
    DreamEditor: DreamEditor;
}) {
    const dreamRows = GetDreamRows();
    const hashTags = hashTagsService.GetAllDreamHashTags(dreamRows);
    const id = "dreamEditorHashTagsChevron";
    const dream = DreamEditor.state.dream;
    const shouldOpenByDefault =
        dreamService.DoesDreamHaveAttribute(dream, EDA.problem) &&
        hashTagsService.GetAllHashTagsInDream(dream).length === 0;

    return (
        <div>
            <ChevronPanel
                id={id}
                label="hashtags"
                shouldOpenByDefault={shouldOpenByDefault}
            >
                <div
                    style={{
                        display: `flex`,
                        flexWrap: `wrap`,
                        justifyContent: `center`,
                        marginTop: `6px`,
                    }}
                >
                    {hashTags.map((hashTag) => (
                        <DreamEditorHashTagLink
                            {...{
                                hashTag,
                                DreamEditor,
                                chevronPanelId: dreamEditorChevronPanelId,
                                key: hashTag,
                            }}
                        />
                    ))}
                </div>
            </ChevronPanel>
        </div>
    );
}

export const dreamEditorChevronPanelId = `ChevronPanel_dreamEditorHashTagsChevron`;
